import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    defaultMessage: "There’s a problem with app.",
    description: "title",
    id: "WnlZMO",
  },
  content: {
    defaultMessage:
      "Siyool couldn’t fetch crucial information regarding installation. Without those System can’t install the app in your Siyool. Please use the button below to get back to system’s dashboard.",
    description: "content",
    id: "zFX5br",
  },
  backButton: {
    defaultMessage: "Back to homepage",
    description: "button",
    id: "906uUr",
  },
});
